import _assertThisInitialized from "/home/ubuntu/rina_code/without-antd/tilia-earth/node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js";
import _toConsumableArray from "/home/ubuntu/rina_code/without-antd/tilia-earth/node_modules/@babel/runtime/helpers/esm/toConsumableArray.js";
import _asyncToGenerator from "/home/ubuntu/rina_code/without-antd/tilia-earth/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "/home/ubuntu/rina_code/without-antd/tilia-earth/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/ubuntu/rina_code/without-antd/tilia-earth/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/home/ubuntu/rina_code/without-antd/tilia-earth/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _createSuper from "/home/ubuntu/rina_code/without-antd/tilia-earth/node_modules/@babel/runtime/helpers/esm/createSuper.js";
import _createForOfIteratorHelper from "/home/ubuntu/rina_code/without-antd/tilia-earth/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _regeneratorRuntime from "/home/ubuntu/rina_code/without-antd/tilia-earth/node_modules/@babel/runtime/regenerator/index.js";
import { RELAYER_DEFAULT_PROTOCOL as ge, RELAYER_EVENTS as Z, VERIFY_SERVER as me, EXPIRER_EVENTS as we, PAIRING_EVENTS as ye, Store as k, Core as Se } from "@walletconnect/core";
import { pino as Ee, getDefaultLoggerOptions as Re, generateChildLogger as Ie, getLoggerContext as _e } from "@walletconnect/logger";
import { IEngine as Ne, ISignClient as qe } from "@walletconnect/types";
import { TYPE_1 as fe, createDelayedPromise as x, engineEvent as u, getInternalError as l, calcExpiry as _, isValidObject as z, getRequiredNamespacesFromNamespaces as ve, getSdkError as N, handleDeeplinkRedirect as Pe, isSessionCompatible as Oe, isBrowser as Ve, hashMessage as Y, isExpired as P, MemoryStore as $, isValidParams as E, isUndefined as D, isValidRelays as Te, isValidRequiredNamespaces as xe, isValidNamespaces as j, isConformingNamespaces as ee, isValidString as C, isValidErrorReason as De, isValidRelay as Ce, isValidController as Ae, isValidNamespacesChainId as se, isValidRequest as be, isValidNamespacesRequest as Le, isValidRequestExpiry as $e, isValidResponse as Ge, isValidEvent as Me, isValidNamespacesEvent as Ue, parseExpirerTarget as Qe, isValidId as Ke, getAppMetadata as ke } from "@walletconnect/utils";
import ze, { EventEmitter as Ye } from "events";
import { THIRTY_DAYS as je, SEVEN_DAYS as te, FIVE_MINUTES as y, ONE_DAY as O, THIRTY_SECONDS as ie, ONE_SECOND as Je, toMiliseconds as re } from "@walletconnect/time";
import { payloadId as Xe, isJsonRpcResult as q, isJsonRpcError as f, formatJsonRpcRequest as J, formatJsonRpcResult as Fe, formatJsonRpcError as He, isJsonRpcRequest as We, isJsonRpcResponse as Be } from "@walletconnect/jsonrpc-utils";
var X = "wc",
    F = 2,
    H = "client",
    G = "".concat(X, "@").concat(F, ":").concat(H, ":"),
    M = {
  name: H,
  logger: "error",
  controller: !1,
  relayUrl: "wss://relay.walletconnect.com"
},
    Ze = {
  session_proposal: "session_proposal",
  session_update: "session_update",
  session_extend: "session_extend",
  session_ping: "session_ping",
  session_delete: "session_delete",
  session_expire: "session_expire",
  session_request: "session_request",
  session_request_sent: "session_request_sent",
  session_event: "session_event",
  proposal_expire: "proposal_expire"
},
    es = {
  database: ":memory:"
},
    W = "WALLETCONNECT_DEEPLINK_CHOICE",
    ss = {
  created: "history_created",
  updated: "history_updated",
  deleted: "history_deleted",
  sync: "history_sync"
},
    ts = "history",
    is = "0.3",
    ne = "proposal",
    rs = je,
    oe = "Proposal expired",
    ae = "session",
    A = te,
    ce = "engine",
    V = {
  wc_sessionPropose: {
    req: {
      ttl: y,
      prompt: !0,
      tag: 1100
    },
    res: {
      ttl: y,
      prompt: !1,
      tag: 1101
    }
  },
  wc_sessionSettle: {
    req: {
      ttl: y,
      prompt: !1,
      tag: 1102
    },
    res: {
      ttl: y,
      prompt: !1,
      tag: 1103
    }
  },
  wc_sessionUpdate: {
    req: {
      ttl: O,
      prompt: !1,
      tag: 1104
    },
    res: {
      ttl: O,
      prompt: !1,
      tag: 1105
    }
  },
  wc_sessionExtend: {
    req: {
      ttl: O,
      prompt: !1,
      tag: 1106
    },
    res: {
      ttl: O,
      prompt: !1,
      tag: 1107
    }
  },
  wc_sessionRequest: {
    req: {
      ttl: y,
      prompt: !0,
      tag: 1108
    },
    res: {
      ttl: y,
      prompt: !1,
      tag: 1109
    }
  },
  wc_sessionEvent: {
    req: {
      ttl: y,
      prompt: !0,
      tag: 1110
    },
    res: {
      ttl: y,
      prompt: !1,
      tag: 1111
    }
  },
  wc_sessionDelete: {
    req: {
      ttl: O,
      prompt: !1,
      tag: 1112
    },
    res: {
      ttl: O,
      prompt: !1,
      tag: 1113
    }
  },
  wc_sessionPing: {
    req: {
      ttl: ie,
      prompt: !1,
      tag: 1114
    },
    res: {
      ttl: ie,
      prompt: !1,
      tag: 1115
    }
  }
},
    U = {
  min: y,
  max: te
},
    I = {
  idle: "IDLE",
  active: "ACTIVE"
},
    le = "request",
    pe = ["wc_sessionPropose", "wc_sessionRequest", "wc_authRequest"];

var ns = Object.defineProperty,
    os = Object.defineProperties,
    as = Object.getOwnPropertyDescriptors,
    he = Object.getOwnPropertySymbols,
    cs = Object.prototype.hasOwnProperty,
    ls = Object.prototype.propertyIsEnumerable,
    de = function de(m, r, e) {
  return r in m ? ns(m, r, {
    enumerable: !0,
    configurable: !0,
    writable: !0,
    value: e
  }) : m[r] = e;
},
    g = function g(m, r) {
  for (var e in r || (r = {})) {
    cs.call(r, e) && de(m, e, r[e]);
  }

  if (he) {
    var _iterator = _createForOfIteratorHelper(he(r)),
        _step;

    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var e = _step.value;
        ls.call(r, e) && de(m, e, r[e]);
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  return m;
},
    b = function b(m, r) {
  return os(m, as(r));
};

var ps = /*#__PURE__*/function (_Ne) {
  _inherits(ps, _Ne);

  var _super = _createSuper(ps);

  function ps(r) {
    var _this;

    _classCallCheck(this, ps);

    _this = _super.call(this, r), _this.name = ce, _this.events = new ze(), _this.initialized = !1, _this.ignoredPayloadTypes = [fe], _this.requestQueue = {
      state: I.idle,
      queue: []
    }, _this.sessionRequestQueue = {
      state: I.idle,
      queue: []
    }, _this.requestQueueDelay = Je, _this.init = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.t0 = _this.initialized;

              if (_context.t0) {
                _context.next = 10;
                break;
              }

              _context.next = 4;
              return _this.cleanup();

            case 4:
              _this.registerRelayerEvents();

              _this.registerExpirerEvents();

              _this.registerPairingEvents();

              _this.client.core.pairing.register({
                methods: Object.keys(V)
              });

              _this.initialized = !0;
              setTimeout(function () {
                _this.sessionRequestQueue.queue = _this.getPendingSessionRequests(), _this.processSessionRequestQueue();
              }, re(_this.requestQueueDelay));

            case 10:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })), _this.connect = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(e) {
        var s, t, i, n, o, a, c, p, d, _yield$_this$client$c, v, S, h, R, _x2, w, T, K, _l, _v, L, ue;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.next = 2;
                return _this.isInitialized();

              case 2:
                s = b(g({}, e), {
                  requiredNamespaces: e.requiredNamespaces || {},
                  optionalNamespaces: e.optionalNamespaces || {}
                });
                _context3.next = 5;
                return _this.isValidConnect(s);

              case 5:
                t = s.pairingTopic, i = s.requiredNamespaces, n = s.optionalNamespaces, o = s.sessionProperties, a = s.relays;
                c = t, d = !1;

                if (!(c && (d = _this.client.core.pairing.pairings.get(c).active), !c || !d)) {
                  _context3.next = 14;
                  break;
                }

                _context3.next = 10;
                return _this.client.core.pairing.create();

              case 10:
                _yield$_this$client$c = _context3.sent;
                v = _yield$_this$client$c.topic;
                S = _yield$_this$client$c.uri;
                c = v, p = S;

              case 14:
                _context3.next = 16;
                return _this.client.core.crypto.generateKeyPair();

              case 16:
                h = _context3.sent;
                R = g({
                  requiredNamespaces: i,
                  optionalNamespaces: n,
                  relays: a !== null && a !== void 0 ? a : [{
                    protocol: ge
                  }],
                  proposer: {
                    publicKey: h,
                    metadata: _this.client.metadata
                  }
                }, o && {
                  sessionProperties: o
                });
                _x2 = x(y, oe);
                w = _x2.reject;
                T = _x2.resolve;
                K = _x2.done;

                if (!(_this.events.once(u("session_connect"), /*#__PURE__*/function () {
                  var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(_ref3) {
                    var v, S, B;
                    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
                      while (1) {
                        switch (_context2.prev = _context2.next) {
                          case 0:
                            v = _ref3.error, S = _ref3.session;

                            if (!v) {
                              _context2.next = 5;
                              break;
                            }

                            w(v);
                            _context2.next = 17;
                            break;

                          case 5:
                            if (!S) {
                              _context2.next = 17;
                              break;
                            }

                            S.self.publicKey = h;
                            B = b(g({}, S), {
                              requiredNamespaces: S.requiredNamespaces,
                              optionalNamespaces: S.optionalNamespaces
                            });
                            _context2.next = 10;
                            return _this.client.session.set(S.topic, B);

                          case 10:
                            _context2.next = 12;
                            return _this.setExpiry(S.topic, S.expiry);

                          case 12:
                            _context2.t0 = c;

                            if (!_context2.t0) {
                              _context2.next = 16;
                              break;
                            }

                            _context2.next = 16;
                            return _this.client.core.pairing.updateMetadata({
                              topic: c,
                              metadata: S.peer.metadata
                            });

                          case 16:
                            T(B);

                          case 17:
                          case "end":
                            return _context2.stop();
                        }
                      }
                    }, _callee2);
                  }));

                  return function (_x3) {
                    return _ref4.apply(this, arguments);
                  };
                }()), !c)) {
                  _context3.next = 25;
                  break;
                }

                _l = l("NO_MATCHING_KEY", "connect() pairing topic: ".concat(c)), _v = _l.message;
                throw new Error(_v);

              case 25:
                _context3.next = 27;
                return _this.sendRequest({
                  topic: c,
                  method: "wc_sessionPropose",
                  params: R
                });

              case 27:
                L = _context3.sent;
                ue = _(y);
                _context3.next = 31;
                return _this.setProposal(L, g({
                  id: L,
                  expiry: ue
                }, R));

              case 31:
                return _context3.abrupt("return", {
                  uri: p,
                  approval: K
                });

              case 32:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }));

      return function (_x) {
        return _ref2.apply(this, arguments);
      };
    }(), _this.pair = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(e) {
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.next = 2;
                return _this.isInitialized();

              case 2:
                _context4.next = 4;
                return _this.client.core.pairing.pair(e);

              case 4:
                return _context4.abrupt("return", _context4.sent);

              case 5:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }));

      return function (_x4) {
        return _ref5.apply(this, arguments);
      };
    }(), _this.approve = /*#__PURE__*/function () {
      var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(e) {
        var s, t, i, n, o, a, c, p, d, h, R, w, T, K;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.next = 2;
                return _this.isInitialized();

              case 2:
                _context5.next = 4;
                return _this.isValidApprove(e);

              case 4:
                s = e.id, t = e.relayProtocol, i = e.namespaces, n = e.sessionProperties, o = _this.client.proposal.get(s);
                a = o.pairingTopic, c = o.proposer, p = o.requiredNamespaces, d = o.optionalNamespaces;
                a = a || "", z(p) || (p = ve(i, "approve()"));
                _context5.next = 9;
                return _this.client.core.crypto.generateKeyPair();

              case 9:
                h = _context5.sent;
                R = c.publicKey;
                _context5.next = 13;
                return _this.client.core.crypto.generateSharedKey(h, R);

              case 13:
                w = _context5.sent;
                _context5.t0 = a && s;

                if (!_context5.t0) {
                  _context5.next = 24;
                  break;
                }

                _context5.next = 18;
                return _this.client.core.pairing.updateMetadata({
                  topic: a,
                  metadata: c.metadata
                });

              case 18:
                _context5.next = 20;
                return _this.sendResult({
                  id: s,
                  topic: a,
                  result: {
                    relay: {
                      protocol: t !== null && t !== void 0 ? t : "irn"
                    },
                    responderPublicKey: h
                  }
                });

              case 20:
                _context5.next = 22;
                return _this.client.proposal.delete(s, N("USER_DISCONNECTED"));

              case 22:
                _context5.next = 24;
                return _this.client.core.pairing.activate({
                  topic: a
                });

              case 24:
                T = g({
                  relay: {
                    protocol: t !== null && t !== void 0 ? t : "irn"
                  },
                  namespaces: i,
                  requiredNamespaces: p,
                  optionalNamespaces: d,
                  pairingTopic: a,
                  controller: {
                    publicKey: h,
                    metadata: _this.client.metadata
                  },
                  expiry: _(A)
                }, n && {
                  sessionProperties: n
                });
                _context5.next = 27;
                return _this.client.core.relayer.subscribe(w);

              case 27:
                _context5.next = 29;
                return _this.sendRequest({
                  topic: w,
                  method: "wc_sessionSettle",
                  params: T,
                  throwOnFailedPublish: !0
                });

              case 29:
                K = b(g({}, T), {
                  topic: w,
                  pairingTopic: a,
                  acknowledged: !1,
                  self: T.controller,
                  peer: {
                    publicKey: c.publicKey,
                    metadata: c.metadata
                  },
                  controller: h
                });
                _context5.next = 32;
                return _this.client.session.set(w, K);

              case 32:
                _context5.next = 34;
                return _this.setExpiry(w, _(A));

              case 34:
                return _context5.abrupt("return", {
                  topic: w,
                  acknowledged: function acknowledged() {
                    return new Promise(function (L) {
                      return setTimeout(function () {
                        return L(_this.client.session.get(w));
                      }, 500);
                    });
                  }
                });

              case 35:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5);
      }));

      return function (_x5) {
        return _ref6.apply(this, arguments);
      };
    }(), _this.reject = /*#__PURE__*/function () {
      var _ref7 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(e) {
        var s, t, _this$client$proposal, i;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.next = 2;
                return _this.isInitialized();

              case 2:
                _context6.next = 4;
                return _this.isValidReject(e);

              case 4:
                s = e.id, t = e.reason, _this$client$proposal = _this.client.proposal.get(s), i = _this$client$proposal.pairingTopic;
                _context6.t0 = i;

                if (!_context6.t0) {
                  _context6.next = 11;
                  break;
                }

                _context6.next = 9;
                return _this.sendError(s, i, t);

              case 9:
                _context6.next = 11;
                return _this.client.proposal.delete(s, N("USER_DISCONNECTED"));

              case 11:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6);
      }));

      return function (_x6) {
        return _ref7.apply(this, arguments);
      };
    }(), _this.update = /*#__PURE__*/function () {
      var _ref8 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(e) {
        var s, t, i, _x8, n, o, a;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.next = 2;
                return _this.isInitialized();

              case 2:
                _context7.next = 4;
                return _this.isValidUpdate(e);

              case 4:
                s = e.topic;
                t = e.namespaces;
                _context7.next = 8;
                return _this.sendRequest({
                  topic: s,
                  method: "wc_sessionUpdate",
                  params: {
                    namespaces: t
                  }
                });

              case 8:
                i = _context7.sent;
                _x8 = x();
                n = _x8.done;
                o = _x8.resolve;
                a = _x8.reject;

                _this.events.once(u("session_update", i), function (_ref9) {
                  var c = _ref9.error;
                  c ? a(c) : o();
                });

                _context7.next = 16;
                return _this.client.session.update(s, {
                  namespaces: t
                });

              case 16:
                return _context7.abrupt("return", {
                  acknowledged: n
                });

              case 17:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7);
      }));

      return function (_x7) {
        return _ref8.apply(this, arguments);
      };
    }(), _this.extend = /*#__PURE__*/function () {
      var _ref10 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(e) {
        var s, t, _x10, i, n, o;

        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.next = 2;
                return _this.isInitialized();

              case 2:
                _context8.next = 4;
                return _this.isValidExtend(e);

              case 4:
                s = e.topic;
                _context8.next = 7;
                return _this.sendRequest({
                  topic: s,
                  method: "wc_sessionExtend",
                  params: {}
                });

              case 7:
                t = _context8.sent;
                _x10 = x();
                i = _x10.done;
                n = _x10.resolve;
                o = _x10.reject;

                _this.events.once(u("session_extend", t), function (_ref11) {
                  var a = _ref11.error;
                  a ? o(a) : n();
                });

                _context8.next = 15;
                return _this.setExpiry(s, _(A));

              case 15:
                return _context8.abrupt("return", {
                  acknowledged: i
                });

              case 16:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8);
      }));

      return function (_x9) {
        return _ref10.apply(this, arguments);
      };
    }(), _this.request = /*#__PURE__*/function () {
      var _ref12 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(e) {
        var s, t, i, n, o, _x12, a, c, p;

        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.next = 2;
                return _this.isInitialized();

              case 2:
                _context11.next = 4;
                return _this.isValidRequest(e);

              case 4:
                s = e.chainId, t = e.request, i = e.topic, n = e.expiry, o = Xe(), _x12 = x(n), a = _x12.done, c = _x12.resolve, p = _x12.reject;

                _this.events.once(u("session_request", o), function (_ref13) {
                  var d = _ref13.error,
                      h = _ref13.result;
                  d ? p(d) : c(h);
                });

                _context11.next = 8;
                return Promise.all([new Promise( /*#__PURE__*/function () {
                  var _ref14 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(d) {
                    return _regeneratorRuntime.wrap(function _callee9$(_context9) {
                      while (1) {
                        switch (_context9.prev = _context9.next) {
                          case 0:
                            _context9.next = 2;
                            return _this.sendRequest({
                              clientRpcId: o,
                              topic: i,
                              method: "wc_sessionRequest",
                              params: {
                                request: t,
                                chainId: s
                              },
                              expiry: n,
                              throwOnFailedPublish: !0
                            }).catch(function (h) {
                              return p(h);
                            });

                          case 2:
                            _this.client.events.emit("session_request_sent", {
                              topic: i,
                              request: t,
                              chainId: s,
                              id: o
                            });

                            d();

                          case 4:
                          case "end":
                            return _context9.stop();
                        }
                      }
                    }, _callee9);
                  }));

                  return function (_x13) {
                    return _ref14.apply(this, arguments);
                  };
                }()), new Promise( /*#__PURE__*/function () {
                  var _ref15 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(d) {
                    var h;
                    return _regeneratorRuntime.wrap(function _callee10$(_context10) {
                      while (1) {
                        switch (_context10.prev = _context10.next) {
                          case 0:
                            _context10.next = 2;
                            return _this.client.core.storage.getItem(W);

                          case 2:
                            h = _context10.sent;
                            Pe({
                              id: o,
                              topic: i,
                              wcDeepLink: h
                            }), d();

                          case 4:
                          case "end":
                            return _context10.stop();
                        }
                      }
                    }, _callee10);
                  }));

                  return function (_x14) {
                    return _ref15.apply(this, arguments);
                  };
                }()), a()]).then(function (d) {
                  return d[2];
                });

              case 8:
                return _context11.abrupt("return", _context11.sent);

              case 9:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11);
      }));

      return function (_x11) {
        return _ref12.apply(this, arguments);
      };
    }(), _this.respond = /*#__PURE__*/function () {
      var _ref16 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(e) {
        var s, t, i;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return _this.isInitialized();

              case 2:
                _context12.next = 4;
                return _this.isValidRespond(e);

              case 4:
                s = e.topic, t = e.response, i = t.id;

                if (!q(t)) {
                  _context12.next = 10;
                  break;
                }

                _context12.next = 8;
                return _this.sendResult({
                  id: i,
                  topic: s,
                  result: t.result,
                  throwOnFailedPublish: !0
                });

              case 8:
                _context12.next = 14;
                break;

              case 10:
                _context12.t0 = f(t);

                if (!_context12.t0) {
                  _context12.next = 14;
                  break;
                }

                _context12.next = 14;
                return _this.sendError(i, s, t.error);

              case 14:
                _this.cleanupAfterResponse(e);

              case 15:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12);
      }));

      return function (_x15) {
        return _ref16.apply(this, arguments);
      };
    }(), _this.ping = /*#__PURE__*/function () {
      var _ref17 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(e) {
        var s, t, _x17, i, n, o;

        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.next = 2;
                return _this.isInitialized();

              case 2:
                _context13.next = 4;
                return _this.isValidPing(e);

              case 4:
                s = e.topic;

                if (!_this.client.session.keys.includes(s)) {
                  _context13.next = 18;
                  break;
                }

                _context13.next = 8;
                return _this.sendRequest({
                  topic: s,
                  method: "wc_sessionPing",
                  params: {}
                });

              case 8:
                t = _context13.sent;
                _x17 = x();
                i = _x17.done;
                n = _x17.resolve;
                o = _x17.reject;

                _this.events.once(u("session_ping", t), function (_ref18) {
                  var a = _ref18.error;
                  a ? o(a) : n();
                });

                _context13.next = 16;
                return i();

              case 16:
                _context13.next = 22;
                break;

              case 18:
                _context13.t0 = _this.client.core.pairing.pairings.keys.includes(s);

                if (!_context13.t0) {
                  _context13.next = 22;
                  break;
                }

                _context13.next = 22;
                return _this.client.core.pairing.ping({
                  topic: s
                });

              case 22:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13);
      }));

      return function (_x16) {
        return _ref17.apply(this, arguments);
      };
    }(), _this.emit = /*#__PURE__*/function () {
      var _ref19 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(e) {
        var s, t, i;
        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.next = 2;
                return _this.isInitialized();

              case 2:
                _context14.next = 4;
                return _this.isValidEmit(e);

              case 4:
                s = e.topic, t = e.event, i = e.chainId;
                _context14.next = 7;
                return _this.sendRequest({
                  topic: s,
                  method: "wc_sessionEvent",
                  params: {
                    event: t,
                    chainId: i
                  }
                });

              case 7:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14);
      }));

      return function (_x18) {
        return _ref19.apply(this, arguments);
      };
    }(), _this.disconnect = /*#__PURE__*/function () {
      var _ref20 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(e) {
        var s;
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.next = 2;
                return _this.isInitialized();

              case 2:
                _context15.next = 4;
                return _this.isValidDisconnect(e);

              case 4:
                s = e.topic;

                if (!_this.client.session.keys.includes(s)) {
                  _context15.next = 12;
                  break;
                }

                _context15.next = 8;
                return _this.sendRequest({
                  topic: s,
                  method: "wc_sessionDelete",
                  params: N("USER_DISCONNECTED"),
                  throwOnFailedPublish: !0
                });

              case 8:
                _context15.next = 10;
                return _this.deleteSession(s);

              case 10:
                _context15.next = 14;
                break;

              case 12:
                _context15.next = 14;
                return _this.client.core.pairing.disconnect({
                  topic: s
                });

              case 14:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15);
      }));

      return function (_x19) {
        return _ref20.apply(this, arguments);
      };
    }(), _this.find = function (e) {
      return _this.isInitialized(), _this.client.session.getAll().filter(function (s) {
        return Oe(s, e);
      });
    }, _this.getPendingSessionRequests = function () {
      return _this.isInitialized(), _this.client.pendingRequest.getAll();
    }, _this.cleanupDuplicatePairings = /*#__PURE__*/function () {
      var _ref21 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(e) {
        var s, t;
        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                if (!e.pairingTopic) {
                  _context16.next = 14;
                  break;
                }

                _context16.prev = 1;
                s = _this.client.core.pairing.pairings.get(e.pairingTopic), t = _this.client.core.pairing.pairings.getAll().filter(function (i) {
                  var n, o;
                  return ((n = i.peerMetadata) == null ? void 0 : n.url) && ((o = i.peerMetadata) == null ? void 0 : o.url) === e.peer.metadata.url && i.topic && i.topic !== s.topic;
                });

                if (!(t.length === 0)) {
                  _context16.next = 5;
                  break;
                }

                return _context16.abrupt("return");

              case 5:
                _this.client.logger.info("Cleaning up ".concat(t.length, " duplicate pairing(s)"));

                _context16.next = 8;
                return Promise.all(t.map(function (i) {
                  return _this.client.core.pairing.disconnect({
                    topic: i.topic
                  });
                }));

              case 8:
                _this.client.logger.info("Duplicate pairings clean up finished");

                _context16.next = 14;
                break;

              case 11:
                _context16.prev = 11;
                _context16.t0 = _context16["catch"](1);

                _this.client.logger.error(_context16.t0);

              case 14:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, null, [[1, 11]]);
      }));

      return function (_x20) {
        return _ref21.apply(this, arguments);
      };
    }(), _this.deleteSession = /*#__PURE__*/function () {
      var _ref22 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(e, s) {
        var _this$client$session$, t;

        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _this$client$session$ = _this.client.session.get(e), t = _this$client$session$.self;
                _context17.next = 3;
                return _this.client.core.relayer.unsubscribe(e);

              case 3:
                _this.client.session.delete(e, N("USER_DISCONNECTED"));

                _context17.t0 = _this.client.core.crypto.keychain.has(t.publicKey);

                if (!_context17.t0) {
                  _context17.next = 8;
                  break;
                }

                _context17.next = 8;
                return _this.client.core.crypto.deleteKeyPair(t.publicKey);

              case 8:
                _context17.t1 = _this.client.core.crypto.keychain.has(e);

                if (!_context17.t1) {
                  _context17.next = 12;
                  break;
                }

                _context17.next = 12;
                return _this.client.core.crypto.deleteSymKey(e);

              case 12:
                s || _this.client.core.expirer.del(e);

                _this.client.core.storage.removeItem(W).catch(function (i) {
                  return _this.client.logger.warn(i);
                });

              case 14:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17);
      }));

      return function (_x21, _x22) {
        return _ref22.apply(this, arguments);
      };
    }(), _this.deleteProposal = /*#__PURE__*/function () {
      var _ref23 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(e, s) {
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.next = 2;
                return Promise.all([_this.client.proposal.delete(e, N("USER_DISCONNECTED")), s ? Promise.resolve() : _this.client.core.expirer.del(e)]);

              case 2:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18);
      }));

      return function (_x23, _x24) {
        return _ref23.apply(this, arguments);
      };
    }(), _this.deletePendingSessionRequest = /*#__PURE__*/function () {
      var _ref24 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(e, s) {
        var t,
            _args19 = arguments;
        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                t = _args19.length > 2 && _args19[2] !== undefined ? _args19[2] : !1;
                _context19.next = 3;
                return Promise.all([_this.client.pendingRequest.delete(e, s), t ? Promise.resolve() : _this.client.core.expirer.del(e)]);

              case 3:
                _this.sessionRequestQueue.queue = _this.sessionRequestQueue.queue.filter(function (i) {
                  return i.id !== e;
                });
                t && (_this.sessionRequestQueue.state = I.idle);

              case 5:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19);
      }));

      return function (_x25, _x26) {
        return _ref24.apply(this, arguments);
      };
    }(), _this.setExpiry = /*#__PURE__*/function () {
      var _ref25 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(e, s) {
        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                _context20.t0 = _this.client.session.keys.includes(e);

                if (!_context20.t0) {
                  _context20.next = 4;
                  break;
                }

                _context20.next = 4;
                return _this.client.session.update(e, {
                  expiry: s
                });

              case 4:
                _this.client.core.expirer.set(e, s);

              case 5:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20);
      }));

      return function (_x27, _x28) {
        return _ref25.apply(this, arguments);
      };
    }(), _this.setProposal = /*#__PURE__*/function () {
      var _ref26 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(e, s) {
        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                _context21.next = 2;
                return _this.client.proposal.set(e, s);

              case 2:
                _this.client.core.expirer.set(e, s.expiry);

              case 3:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21);
      }));

      return function (_x29, _x30) {
        return _ref26.apply(this, arguments);
      };
    }(), _this.setPendingSessionRequest = /*#__PURE__*/function () {
      var _ref27 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(e) {
        var s, t, i, n, o;
        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                s = V.wc_sessionRequest.req.ttl, t = e.id, i = e.topic, n = e.params, o = e.verifyContext;
                _context22.next = 3;
                return _this.client.pendingRequest.set(t, {
                  id: t,
                  topic: i,
                  params: n,
                  verifyContext: o
                });

              case 3:
                s && _this.client.core.expirer.set(t, _(s));

              case 4:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22);
      }));

      return function (_x31) {
        return _ref27.apply(this, arguments);
      };
    }(), _this.sendRequest = /*#__PURE__*/function () {
      var _ref28 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(e) {
        var s, t, i, n, o, a, c, p, R, d, h;
        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                s = e.topic, t = e.method, i = e.params, n = e.expiry, o = e.relayRpcId, a = e.clientRpcId, c = e.throwOnFailedPublish, p = J(t, i, a);

                if (Ve() && pe.includes(t)) {
                  R = Y(JSON.stringify(p));

                  _this.client.core.verify.register({
                    attestationId: R
                  });
                }

                _context23.next = 4;
                return _this.client.core.crypto.encode(s, p);

              case 4:
                d = _context23.sent;
                h = V[t].req;
                n && (h.ttl = n);
                o && (h.id = o);

                _this.client.core.history.set(s, p);

                if (!c) {
                  _context23.next = 15;
                  break;
                }

                h.internal = b(g({}, h.internal), {
                  throwOnFailedPublish: !0
                });
                _context23.next = 13;
                return _this.client.core.relayer.publish(s, d, h);

              case 13:
                _context23.next = 16;
                break;

              case 15:
                _this.client.core.relayer.publish(s, d, h).catch(function (R) {
                  return _this.client.logger.error(R);
                });

              case 16:
                return _context23.abrupt("return", p.id);

              case 17:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23);
      }));

      return function (_x32) {
        return _ref28.apply(this, arguments);
      };
    }(), _this.sendResult = /*#__PURE__*/function () {
      var _ref29 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee24(e) {
        var s, t, i, n, o, a, c, p;
        return _regeneratorRuntime.wrap(function _callee24$(_context24) {
          while (1) {
            switch (_context24.prev = _context24.next) {
              case 0:
                s = e.id;
                t = e.topic;
                i = e.result;
                n = e.throwOnFailedPublish;
                o = Fe(s, i);
                _context24.next = 7;
                return _this.client.core.crypto.encode(t, o);

              case 7:
                a = _context24.sent;
                _context24.next = 10;
                return _this.client.core.history.get(t, s);

              case 10:
                c = _context24.sent;
                p = V[c.request.method].res;

                if (!n) {
                  _context24.next = 18;
                  break;
                }

                p.internal = b(g({}, p.internal), {
                  throwOnFailedPublish: !0
                });
                _context24.next = 16;
                return _this.client.core.relayer.publish(t, a, p);

              case 16:
                _context24.next = 19;
                break;

              case 18:
                _this.client.core.relayer.publish(t, a, p).catch(function (d) {
                  return _this.client.logger.error(d);
                });

              case 19:
                _context24.next = 21;
                return _this.client.core.history.resolve(o);

              case 21:
              case "end":
                return _context24.stop();
            }
          }
        }, _callee24);
      }));

      return function (_x33) {
        return _ref29.apply(this, arguments);
      };
    }(), _this.sendError = /*#__PURE__*/function () {
      var _ref30 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee25(e, s, t) {
        var i, n, o, a;
        return _regeneratorRuntime.wrap(function _callee25$(_context25) {
          while (1) {
            switch (_context25.prev = _context25.next) {
              case 0:
                i = He(e, t);
                _context25.next = 3;
                return _this.client.core.crypto.encode(s, i);

              case 3:
                n = _context25.sent;
                _context25.next = 6;
                return _this.client.core.history.get(s, e);

              case 6:
                o = _context25.sent;
                a = V[o.request.method].res;

                _this.client.core.relayer.publish(s, n, a);

                _context25.next = 11;
                return _this.client.core.history.resolve(i);

              case 11:
              case "end":
                return _context25.stop();
            }
          }
        }, _callee25);
      }));

      return function (_x34, _x35, _x36) {
        return _ref30.apply(this, arguments);
      };
    }(), _this.cleanup = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee26() {
      var e, s;
      return _regeneratorRuntime.wrap(function _callee26$(_context26) {
        while (1) {
          switch (_context26.prev = _context26.next) {
            case 0:
              e = [], s = [];

              _this.client.session.getAll().forEach(function (t) {
                P(t.expiry) && e.push(t.topic);
              });

              _this.client.proposal.getAll().forEach(function (t) {
                P(t.expiry) && s.push(t.id);
              });

              _context26.next = 5;
              return Promise.all([].concat(_toConsumableArray(e.map(function (t) {
                return _this.deleteSession(t);
              })), _toConsumableArray(s.map(function (t) {
                return _this.deleteProposal(t);
              }))));

            case 5:
            case "end":
              return _context26.stop();
          }
        }
      }, _callee26);
    })), _this.onRelayEventRequest = /*#__PURE__*/function () {
      var _ref32 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee27(e) {
        return _regeneratorRuntime.wrap(function _callee27$(_context27) {
          while (1) {
            switch (_context27.prev = _context27.next) {
              case 0:
                _this.requestQueue.queue.push(e);

                _context27.next = 3;
                return _this.processRequestsQueue();

              case 3:
              case "end":
                return _context27.stop();
            }
          }
        }, _callee27);
      }));

      return function (_x37) {
        return _ref32.apply(this, arguments);
      };
    }(), _this.processRequestsQueue = /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee28() {
      var e;
      return _regeneratorRuntime.wrap(function _callee28$(_context28) {
        while (1) {
          switch (_context28.prev = _context28.next) {
            case 0:
              if (!(_this.requestQueue.state === I.active)) {
                _context28.next = 3;
                break;
              }

              _this.client.logger.info("Request queue already active, skipping...");

              return _context28.abrupt("return");

            case 3:
              _this.client.logger.info("Request queue starting with ".concat(_this.requestQueue.queue.length, " requests"));

            case 4:
              if (!(_this.requestQueue.queue.length > 0)) {
                _context28.next = 19;
                break;
              }

              _this.requestQueue.state = I.active;
              e = _this.requestQueue.queue.shift();

              if (!e) {
                _context28.next = 17;
                break;
              }

              _context28.prev = 8;

              _this.processRequest(e);

              _context28.next = 12;
              return new Promise(function (s) {
                return setTimeout(s, 300);
              });

            case 12:
              _context28.next = 17;
              break;

            case 14:
              _context28.prev = 14;
              _context28.t0 = _context28["catch"](8);

              _this.client.logger.warn(_context28.t0);

            case 17:
              _context28.next = 4;
              break;

            case 19:
              _this.requestQueue.state = I.idle;

            case 20:
            case "end":
              return _context28.stop();
          }
        }
      }, _callee28, null, [[8, 14]]);
    })), _this.processRequest = function (e) {
      var s = e.topic,
          t = e.payload,
          i = t.method;

      switch (i) {
        case "wc_sessionPropose":
          return _this.onSessionProposeRequest(s, t);

        case "wc_sessionSettle":
          return _this.onSessionSettleRequest(s, t);

        case "wc_sessionUpdate":
          return _this.onSessionUpdateRequest(s, t);

        case "wc_sessionExtend":
          return _this.onSessionExtendRequest(s, t);

        case "wc_sessionPing":
          return _this.onSessionPingRequest(s, t);

        case "wc_sessionDelete":
          return _this.onSessionDeleteRequest(s, t);

        case "wc_sessionRequest":
          return _this.onSessionRequest(s, t);

        case "wc_sessionEvent":
          return _this.onSessionEventRequest(s, t);

        default:
          return _this.client.logger.info("Unsupported request method ".concat(i));
      }
    }, _this.onRelayEventResponse = /*#__PURE__*/function () {
      var _ref34 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee29(e) {
        var s, t, i;
        return _regeneratorRuntime.wrap(function _callee29$(_context29) {
          while (1) {
            switch (_context29.prev = _context29.next) {
              case 0:
                s = e.topic;
                t = e.payload;
                _context29.next = 4;
                return _this.client.core.history.get(s, t.id);

              case 4:
                i = _context29.sent.request.method;
                _context29.t0 = i;
                _context29.next = _context29.t0 === "wc_sessionPropose" ? 8 : _context29.t0 === "wc_sessionSettle" ? 9 : _context29.t0 === "wc_sessionUpdate" ? 10 : _context29.t0 === "wc_sessionExtend" ? 11 : _context29.t0 === "wc_sessionPing" ? 12 : _context29.t0 === "wc_sessionRequest" ? 13 : 14;
                break;

              case 8:
                return _context29.abrupt("return", _this.onSessionProposeResponse(s, t));

              case 9:
                return _context29.abrupt("return", _this.onSessionSettleResponse(s, t));

              case 10:
                return _context29.abrupt("return", _this.onSessionUpdateResponse(s, t));

              case 11:
                return _context29.abrupt("return", _this.onSessionExtendResponse(s, t));

              case 12:
                return _context29.abrupt("return", _this.onSessionPingResponse(s, t));

              case 13:
                return _context29.abrupt("return", _this.onSessionRequestResponse(s, t));

              case 14:
                return _context29.abrupt("return", _this.client.logger.info("Unsupported response method ".concat(i)));

              case 15:
              case "end":
                return _context29.stop();
            }
          }
        }, _callee29);
      }));

      return function (_x38) {
        return _ref34.apply(this, arguments);
      };
    }(), _this.onRelayEventUnknownPayload = function (e) {
      var s = e.topic,
          _l2 = l("MISSING_OR_INVALID", "Decoded payload on topic ".concat(s, " is not identifiable as a JSON-RPC request or a response.")),
          t = _l2.message;

      throw new Error(t);
    }, _this.onSessionProposeRequest = /*#__PURE__*/function () {
      var _ref35 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee30(e, s) {
        var t, i, n, o, a, c;
        return _regeneratorRuntime.wrap(function _callee30$(_context30) {
          while (1) {
            switch (_context30.prev = _context30.next) {
              case 0:
                t = s.params, i = s.id;
                _context30.prev = 1;

                _this.isValidConnect(g({}, s.params));

                n = _(y), o = g({
                  id: i,
                  pairingTopic: e,
                  expiry: n
                }, t);
                _context30.next = 6;
                return _this.setProposal(i, o);

              case 6:
                a = Y(JSON.stringify(s));
                _context30.next = 9;
                return _this.getVerifyContext(a, o.proposer.metadata);

              case 9:
                c = _context30.sent;

                _this.client.events.emit("session_proposal", {
                  id: i,
                  params: o,
                  verifyContext: c
                });

                _context30.next = 18;
                break;

              case 13:
                _context30.prev = 13;
                _context30.t0 = _context30["catch"](1);
                _context30.next = 17;
                return _this.sendError(i, e, _context30.t0);

              case 17:
                _this.client.logger.error(_context30.t0);

              case 18:
              case "end":
                return _context30.stop();
            }
          }
        }, _callee30, null, [[1, 13]]);
      }));

      return function (_x39, _x40) {
        return _ref35.apply(this, arguments);
      };
    }(), _this.onSessionProposeResponse = /*#__PURE__*/function () {
      var _ref36 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee31(e, s) {
        var t, i, n, o, a, c, p;
        return _regeneratorRuntime.wrap(function _callee31$(_context31) {
          while (1) {
            switch (_context31.prev = _context31.next) {
              case 0:
                t = s.id;

                if (!q(s)) {
                  _context31.next = 22;
                  break;
                }

                i = s.result;

                _this.client.logger.trace({
                  type: "method",
                  method: "onSessionProposeResponse",
                  result: i
                });

                n = _this.client.proposal.get(t);

                _this.client.logger.trace({
                  type: "method",
                  method: "onSessionProposeResponse",
                  proposal: n
                });

                o = n.proposer.publicKey;

                _this.client.logger.trace({
                  type: "method",
                  method: "onSessionProposeResponse",
                  selfPublicKey: o
                });

                a = i.responderPublicKey;

                _this.client.logger.trace({
                  type: "method",
                  method: "onSessionProposeResponse",
                  peerPublicKey: a
                });

                _context31.next = 12;
                return _this.client.core.crypto.generateSharedKey(o, a);

              case 12:
                c = _context31.sent;

                _this.client.logger.trace({
                  type: "method",
                  method: "onSessionProposeResponse",
                  sessionTopic: c
                });

                _context31.next = 16;
                return _this.client.core.relayer.subscribe(c);

              case 16:
                p = _context31.sent;

                _this.client.logger.trace({
                  type: "method",
                  method: "onSessionProposeResponse",
                  subscriptionId: p
                });

                _context31.next = 20;
                return _this.client.core.pairing.activate({
                  topic: e
                });

              case 20:
                _context31.next = 27;
                break;

              case 22:
                _context31.t0 = f(s);

                if (!_context31.t0) {
                  _context31.next = 27;
                  break;
                }

                _context31.next = 26;
                return _this.client.proposal.delete(t, N("USER_DISCONNECTED"));

              case 26:
                _this.events.emit(u("session_connect"), {
                  error: s.error
                });

              case 27:
              case "end":
                return _context31.stop();
            }
          }
        }, _callee31);
      }));

      return function (_x41, _x42) {
        return _ref36.apply(this, arguments);
      };
    }(), _this.onSessionSettleRequest = /*#__PURE__*/function () {
      var _ref37 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee32(e, s) {
        var t, i, _s$params, n, o, a, c, p, d, h, R, w;

        return _regeneratorRuntime.wrap(function _callee32$(_context32) {
          while (1) {
            switch (_context32.prev = _context32.next) {
              case 0:
                t = s.id, i = s.params;
                _context32.prev = 1;

                _this.isValidSessionSettleRequest(i);

                _s$params = s.params, n = _s$params.relay, o = _s$params.controller, a = _s$params.expiry, c = _s$params.namespaces, p = _s$params.requiredNamespaces, d = _s$params.optionalNamespaces, h = _s$params.sessionProperties, R = _s$params.pairingTopic, w = g({
                  topic: e,
                  relay: n,
                  expiry: a,
                  namespaces: c,
                  acknowledged: !0,
                  pairingTopic: R,
                  requiredNamespaces: p,
                  optionalNamespaces: d,
                  controller: o.publicKey,
                  self: {
                    publicKey: "",
                    metadata: _this.client.metadata
                  },
                  peer: {
                    publicKey: o.publicKey,
                    metadata: o.metadata
                  }
                }, h && {
                  sessionProperties: h
                });
                _context32.next = 6;
                return _this.sendResult({
                  id: s.id,
                  topic: e,
                  result: !0
                });

              case 6:
                _this.events.emit(u("session_connect"), {
                  session: w
                });

                _this.cleanupDuplicatePairings(w);

                _context32.next = 15;
                break;

              case 10:
                _context32.prev = 10;
                _context32.t0 = _context32["catch"](1);
                _context32.next = 14;
                return _this.sendError(t, e, _context32.t0);

              case 14:
                _this.client.logger.error(_context32.t0);

              case 15:
              case "end":
                return _context32.stop();
            }
          }
        }, _callee32, null, [[1, 10]]);
      }));

      return function (_x43, _x44) {
        return _ref37.apply(this, arguments);
      };
    }(), _this.onSessionSettleResponse = /*#__PURE__*/function () {
      var _ref38 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee33(e, s) {
        var t;
        return _regeneratorRuntime.wrap(function _callee33$(_context33) {
          while (1) {
            switch (_context33.prev = _context33.next) {
              case 0:
                t = s.id;

                if (!q(s)) {
                  _context33.next = 7;
                  break;
                }

                _context33.next = 4;
                return _this.client.session.update(e, {
                  acknowledged: !0
                });

              case 4:
                _this.events.emit(u("session_approve", t), {});

                _context33.next = 12;
                break;

              case 7:
                _context33.t0 = f(s);

                if (!_context33.t0) {
                  _context33.next = 12;
                  break;
                }

                _context33.next = 11;
                return _this.client.session.delete(e, N("USER_DISCONNECTED"));

              case 11:
                _this.events.emit(u("session_approve", t), {
                  error: s.error
                });

              case 12:
              case "end":
                return _context33.stop();
            }
          }
        }, _callee33);
      }));

      return function (_x45, _x46) {
        return _ref38.apply(this, arguments);
      };
    }(), _this.onSessionUpdateRequest = /*#__PURE__*/function () {
      var _ref39 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee34(e, s) {
        var t, i, n, o;
        return _regeneratorRuntime.wrap(function _callee34$(_context34) {
          while (1) {
            switch (_context34.prev = _context34.next) {
              case 0:
                t = s.params, i = s.id;
                _context34.prev = 1;
                n = "".concat(e, "_session_update"), o = $.get(n);

                if (!(o && _this.isRequestOutOfSync(o, i))) {
                  _context34.next = 6;
                  break;
                }

                _this.client.logger.info("Discarding out of sync request - ".concat(i));

                return _context34.abrupt("return");

              case 6:
                _this.isValidUpdate(g({
                  topic: e
                }, t));

                _context34.next = 9;
                return _this.client.session.update(e, {
                  namespaces: t.namespaces
                });

              case 9:
                _context34.next = 11;
                return _this.sendResult({
                  id: i,
                  topic: e,
                  result: !0
                });

              case 11:
                _this.client.events.emit("session_update", {
                  id: i,
                  topic: e,
                  params: t
                });

                $.set(n, i);
                _context34.next = 20;
                break;

              case 15:
                _context34.prev = 15;
                _context34.t0 = _context34["catch"](1);
                _context34.next = 19;
                return _this.sendError(i, e, _context34.t0);

              case 19:
                _this.client.logger.error(_context34.t0);

              case 20:
              case "end":
                return _context34.stop();
            }
          }
        }, _callee34, null, [[1, 15]]);
      }));

      return function (_x47, _x48) {
        return _ref39.apply(this, arguments);
      };
    }(), _this.isRequestOutOfSync = function (e, s) {
      return parseInt(s.toString().slice(0, -3)) <= parseInt(e.toString().slice(0, -3));
    }, _this.onSessionUpdateResponse = function (e, s) {
      var t = s.id;
      q(s) ? _this.events.emit(u("session_update", t), {}) : f(s) && _this.events.emit(u("session_update", t), {
        error: s.error
      });
    }, _this.onSessionExtendRequest = /*#__PURE__*/function () {
      var _ref40 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee35(e, s) {
        var t;
        return _regeneratorRuntime.wrap(function _callee35$(_context35) {
          while (1) {
            switch (_context35.prev = _context35.next) {
              case 0:
                t = s.id;
                _context35.prev = 1;

                _this.isValidExtend({
                  topic: e
                });

                _context35.next = 5;
                return _this.setExpiry(e, _(A));

              case 5:
                _context35.next = 7;
                return _this.sendResult({
                  id: t,
                  topic: e,
                  result: !0
                });

              case 7:
                _this.client.events.emit("session_extend", {
                  id: t,
                  topic: e
                });

                _context35.next = 15;
                break;

              case 10:
                _context35.prev = 10;
                _context35.t0 = _context35["catch"](1);
                _context35.next = 14;
                return _this.sendError(t, e, _context35.t0);

              case 14:
                _this.client.logger.error(_context35.t0);

              case 15:
              case "end":
                return _context35.stop();
            }
          }
        }, _callee35, null, [[1, 10]]);
      }));

      return function (_x49, _x50) {
        return _ref40.apply(this, arguments);
      };
    }(), _this.onSessionExtendResponse = function (e, s) {
      var t = s.id;
      q(s) ? _this.events.emit(u("session_extend", t), {}) : f(s) && _this.events.emit(u("session_extend", t), {
        error: s.error
      });
    }, _this.onSessionPingRequest = /*#__PURE__*/function () {
      var _ref41 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee36(e, s) {
        var t;
        return _regeneratorRuntime.wrap(function _callee36$(_context36) {
          while (1) {
            switch (_context36.prev = _context36.next) {
              case 0:
                t = s.id;
                _context36.prev = 1;

                _this.isValidPing({
                  topic: e
                });

                _context36.next = 5;
                return _this.sendResult({
                  id: t,
                  topic: e,
                  result: !0
                });

              case 5:
                _this.client.events.emit("session_ping", {
                  id: t,
                  topic: e
                });

                _context36.next = 13;
                break;

              case 8:
                _context36.prev = 8;
                _context36.t0 = _context36["catch"](1);
                _context36.next = 12;
                return _this.sendError(t, e, _context36.t0);

              case 12:
                _this.client.logger.error(_context36.t0);

              case 13:
              case "end":
                return _context36.stop();
            }
          }
        }, _callee36, null, [[1, 8]]);
      }));

      return function (_x51, _x52) {
        return _ref41.apply(this, arguments);
      };
    }(), _this.onSessionPingResponse = function (e, s) {
      var t = s.id;
      setTimeout(function () {
        q(s) ? _this.events.emit(u("session_ping", t), {}) : f(s) && _this.events.emit(u("session_ping", t), {
          error: s.error
        });
      }, 500);
    }, _this.onSessionDeleteRequest = /*#__PURE__*/function () {
      var _ref42 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee38(e, s) {
        var t;
        return _regeneratorRuntime.wrap(function _callee38$(_context38) {
          while (1) {
            switch (_context38.prev = _context38.next) {
              case 0:
                t = s.id;
                _context38.prev = 1;

                _this.isValidDisconnect({
                  topic: e,
                  reason: s.params
                });

                _context38.next = 5;
                return Promise.all([new Promise(function (i) {
                  _this.client.core.relayer.once(Z.publish, /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee37() {
                    return _regeneratorRuntime.wrap(function _callee37$(_context37) {
                      while (1) {
                        switch (_context37.prev = _context37.next) {
                          case 0:
                            _context37.t0 = i;
                            _context37.next = 3;
                            return _this.deleteSession(e);

                          case 3:
                            _context37.t1 = _context37.sent;
                            (0, _context37.t0)(_context37.t1);

                          case 5:
                          case "end":
                            return _context37.stop();
                        }
                      }
                    }, _callee37);
                  })));
                }), _this.sendResult({
                  id: t,
                  topic: e,
                  result: !0
                })]);

              case 5:
                _this.client.events.emit("session_delete", {
                  id: t,
                  topic: e
                });

                _context38.next = 11;
                break;

              case 8:
                _context38.prev = 8;
                _context38.t0 = _context38["catch"](1);

                _this.client.logger.error(_context38.t0);

              case 11:
              case "end":
                return _context38.stop();
            }
          }
        }, _callee38, null, [[1, 8]]);
      }));

      return function (_x53, _x54) {
        return _ref42.apply(this, arguments);
      };
    }(), _this.onSessionRequest = /*#__PURE__*/function () {
      var _ref44 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee39(e, s) {
        var t, i, n, o, a, c;
        return _regeneratorRuntime.wrap(function _callee39$(_context39) {
          while (1) {
            switch (_context39.prev = _context39.next) {
              case 0:
                t = s.id, i = s.params;
                _context39.prev = 1;

                _this.isValidRequest(g({
                  topic: e
                }, i));

                n = Y(JSON.stringify(J("wc_sessionRequest", i, t)));
                o = _this.client.session.get(e);
                _context39.next = 7;
                return _this.getVerifyContext(n, o.peer.metadata);

              case 7:
                a = _context39.sent;
                c = {
                  id: t,
                  topic: e,
                  params: i,
                  verifyContext: a
                };
                _context39.next = 11;
                return _this.setPendingSessionRequest(c);

              case 11:
                _this.addSessionRequestToSessionRequestQueue(c);

                _this.processSessionRequestQueue();

                _context39.next = 20;
                break;

              case 15:
                _context39.prev = 15;
                _context39.t0 = _context39["catch"](1);
                _context39.next = 19;
                return _this.sendError(t, e, _context39.t0);

              case 19:
                _this.client.logger.error(_context39.t0);

              case 20:
              case "end":
                return _context39.stop();
            }
          }
        }, _callee39, null, [[1, 15]]);
      }));

      return function (_x55, _x56) {
        return _ref44.apply(this, arguments);
      };
    }(), _this.onSessionRequestResponse = function (e, s) {
      var t = s.id;
      q(s) ? _this.events.emit(u("session_request", t), {
        result: s.result
      }) : f(s) && _this.events.emit(u("session_request", t), {
        error: s.error
      });
    }, _this.onSessionEventRequest = /*#__PURE__*/function () {
      var _ref45 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee40(e, s) {
        var t, i, n, o;
        return _regeneratorRuntime.wrap(function _callee40$(_context40) {
          while (1) {
            switch (_context40.prev = _context40.next) {
              case 0:
                t = s.id, i = s.params;
                _context40.prev = 1;
                n = "".concat(e, "_session_event_").concat(i.event.name), o = $.get(n);

                if (!(o && _this.isRequestOutOfSync(o, t))) {
                  _context40.next = 6;
                  break;
                }

                _this.client.logger.info("Discarding out of sync request - ".concat(t));

                return _context40.abrupt("return");

              case 6:
                _this.isValidEmit(g({
                  topic: e
                }, i)), _this.client.events.emit("session_event", {
                  id: t,
                  topic: e,
                  params: i
                }), $.set(n, t);
                _context40.next = 14;
                break;

              case 9:
                _context40.prev = 9;
                _context40.t0 = _context40["catch"](1);
                _context40.next = 13;
                return _this.sendError(t, e, _context40.t0);

              case 13:
                _this.client.logger.error(_context40.t0);

              case 14:
              case "end":
                return _context40.stop();
            }
          }
        }, _callee40, null, [[1, 9]]);
      }));

      return function (_x57, _x58) {
        return _ref45.apply(this, arguments);
      };
    }(), _this.addSessionRequestToSessionRequestQueue = function (e) {
      _this.sessionRequestQueue.queue.push(e);
    }, _this.cleanupAfterResponse = function (e) {
      _this.deletePendingSessionRequest(e.response.id, {
        message: "fulfilled",
        code: 0
      }), setTimeout(function () {
        _this.sessionRequestQueue.state = I.idle, _this.processSessionRequestQueue();
      }, re(_this.requestQueueDelay));
    }, _this.processSessionRequestQueue = function () {
      if (_this.sessionRequestQueue.state === I.active) {
        _this.client.logger.info("session request queue is already active.");

        return;
      }

      var e = _this.sessionRequestQueue.queue[0];

      if (!e) {
        _this.client.logger.info("session request queue is empty.");

        return;
      }

      try {
        _this.sessionRequestQueue.state = I.active, _this.client.events.emit("session_request", e);
      } catch (s) {
        _this.client.logger.error(s);
      }
    }, _this.onPairingCreated = function (e) {
      if (e.active) return;

      var s = _this.client.proposal.getAll().find(function (t) {
        return t.pairingTopic === e.topic;
      });

      s && _this.onSessionProposeRequest(e.topic, J("wc_sessionPropose", {
        requiredNamespaces: s.requiredNamespaces,
        optionalNamespaces: s.optionalNamespaces,
        relays: s.relays,
        proposer: s.proposer
      }, s.id));
    }, _this.isValidConnect = /*#__PURE__*/function () {
      var _ref46 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee41(e) {
        var _l3, a, s, t, i, n, o, _l4, _a;

        return _regeneratorRuntime.wrap(function _callee41$(_context41) {
          while (1) {
            switch (_context41.prev = _context41.next) {
              case 0:
                if (E(e)) {
                  _context41.next = 3;
                  break;
                }

                _l3 = l("MISSING_OR_INVALID", "connect() params: ".concat(JSON.stringify(e))), a = _l3.message;
                throw new Error(a);

              case 3:
                s = e.pairingTopic, t = e.requiredNamespaces, i = e.optionalNamespaces, n = e.sessionProperties, o = e.relays;
                _context41.t0 = D(s);

                if (_context41.t0) {
                  _context41.next = 8;
                  break;
                }

                _context41.next = 8;
                return _this.isValidPairingTopic(s);

              case 8:
                if (Te(o, !0)) {
                  _context41.next = 11;
                  break;
                }

                _l4 = l("MISSING_OR_INVALID", "connect() relays: ".concat(o)), _a = _l4.message;
                throw new Error(_a);

              case 11:
                !D(t) && z(t) !== 0 && _this.validateNamespaces(t, "requiredNamespaces"), !D(i) && z(i) !== 0 && _this.validateNamespaces(i, "optionalNamespaces"), D(n) || _this.validateSessionProps(n, "sessionProperties");

              case 12:
              case "end":
                return _context41.stop();
            }
          }
        }, _callee41);
      }));

      return function (_x59) {
        return _ref46.apply(this, arguments);
      };
    }(), _this.validateNamespaces = function (e, s) {
      var t = xe(e, "connect()", s);
      if (t) throw new Error(t.message);
    }, _this.isValidApprove = /*#__PURE__*/function () {
      var _ref47 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee42(e) {
        var s, t, i, n, o, a, c, _l5, p;

        return _regeneratorRuntime.wrap(function _callee42$(_context42) {
          while (1) {
            switch (_context42.prev = _context42.next) {
              case 0:
                if (E(e)) {
                  _context42.next = 2;
                  break;
                }

                throw new Error(l("MISSING_OR_INVALID", "approve() params: ".concat(e)).message);

              case 2:
                s = e.id, t = e.namespaces, i = e.relayProtocol, n = e.sessionProperties;
                _context42.next = 5;
                return _this.isValidProposalId(s);

              case 5:
                o = _this.client.proposal.get(s), a = j(t, "approve()");

                if (!a) {
                  _context42.next = 8;
                  break;
                }

                throw new Error(a.message);

              case 8:
                c = ee(o.requiredNamespaces, t, "approve()");

                if (!c) {
                  _context42.next = 11;
                  break;
                }

                throw new Error(c.message);

              case 11:
                if (C(i, !0)) {
                  _context42.next = 14;
                  break;
                }

                _l5 = l("MISSING_OR_INVALID", "approve() relayProtocol: ".concat(i)), p = _l5.message;
                throw new Error(p);

              case 14:
                D(n) || _this.validateSessionProps(n, "sessionProperties");

              case 15:
              case "end":
                return _context42.stop();
            }
          }
        }, _callee42);
      }));

      return function (_x60) {
        return _ref47.apply(this, arguments);
      };
    }(), _this.isValidReject = /*#__PURE__*/function () {
      var _ref48 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee43(e) {
        var _l6, i, s, t, _l7, _i;

        return _regeneratorRuntime.wrap(function _callee43$(_context43) {
          while (1) {
            switch (_context43.prev = _context43.next) {
              case 0:
                if (E(e)) {
                  _context43.next = 3;
                  break;
                }

                _l6 = l("MISSING_OR_INVALID", "reject() params: ".concat(e)), i = _l6.message;
                throw new Error(i);

              case 3:
                s = e.id, t = e.reason;
                _context43.next = 6;
                return _this.isValidProposalId(s);

              case 6:
                if (De(t)) {
                  _context43.next = 9;
                  break;
                }

                _l7 = l("MISSING_OR_INVALID", "reject() reason: ".concat(JSON.stringify(t))), _i = _l7.message;
                throw new Error(_i);

              case 9:
              case "end":
                return _context43.stop();
            }
          }
        }, _callee43);
      }));

      return function (_x61) {
        return _ref48.apply(this, arguments);
      };
    }(), _this.isValidSessionSettleRequest = function (e) {
      if (!E(e)) {
        var _l8 = l("MISSING_OR_INVALID", "onSessionSettleRequest() params: ".concat(e)),
            c = _l8.message;

        throw new Error(c);
      }

      var s = e.relay,
          t = e.controller,
          i = e.namespaces,
          n = e.expiry;

      if (!Ce(s)) {
        var _l9 = l("MISSING_OR_INVALID", "onSessionSettleRequest() relay protocol should be a string"),
            _c = _l9.message;

        throw new Error(_c);
      }

      var o = Ae(t, "onSessionSettleRequest()");
      if (o) throw new Error(o.message);
      var a = j(i, "onSessionSettleRequest()");
      if (a) throw new Error(a.message);

      if (P(n)) {
        var _l10 = l("EXPIRED", "onSessionSettleRequest()"),
            _c2 = _l10.message;

        throw new Error(_c2);
      }
    }, _this.isValidUpdate = /*#__PURE__*/function () {
      var _ref49 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee44(e) {
        var _l11, a, s, t, i, n, o;

        return _regeneratorRuntime.wrap(function _callee44$(_context44) {
          while (1) {
            switch (_context44.prev = _context44.next) {
              case 0:
                if (E(e)) {
                  _context44.next = 3;
                  break;
                }

                _l11 = l("MISSING_OR_INVALID", "update() params: ".concat(e)), a = _l11.message;
                throw new Error(a);

              case 3:
                s = e.topic, t = e.namespaces;
                _context44.next = 6;
                return _this.isValidSessionTopic(s);

              case 6:
                i = _this.client.session.get(s), n = j(t, "update()");

                if (!n) {
                  _context44.next = 9;
                  break;
                }

                throw new Error(n.message);

              case 9:
                o = ee(i.requiredNamespaces, t, "update()");

                if (!o) {
                  _context44.next = 12;
                  break;
                }

                throw new Error(o.message);

              case 12:
              case "end":
                return _context44.stop();
            }
          }
        }, _callee44);
      }));

      return function (_x62) {
        return _ref49.apply(this, arguments);
      };
    }(), _this.isValidExtend = /*#__PURE__*/function () {
      var _ref50 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee45(e) {
        var _l12, t, s;

        return _regeneratorRuntime.wrap(function _callee45$(_context45) {
          while (1) {
            switch (_context45.prev = _context45.next) {
              case 0:
                if (E(e)) {
                  _context45.next = 3;
                  break;
                }

                _l12 = l("MISSING_OR_INVALID", "extend() params: ".concat(e)), t = _l12.message;
                throw new Error(t);

              case 3:
                s = e.topic;
                _context45.next = 6;
                return _this.isValidSessionTopic(s);

              case 6:
              case "end":
                return _context45.stop();
            }
          }
        }, _callee45);
      }));

      return function (_x63) {
        return _ref50.apply(this, arguments);
      };
    }(), _this.isValidRequest = /*#__PURE__*/function () {
      var _ref51 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee46(e) {
        var _l13, a, s, t, i, n, _this$client$session$2, o, _l14, _a2, _l15, _a3, _l16, _a4, _l17, _a5;

        return _regeneratorRuntime.wrap(function _callee46$(_context46) {
          while (1) {
            switch (_context46.prev = _context46.next) {
              case 0:
                if (E(e)) {
                  _context46.next = 3;
                  break;
                }

                _l13 = l("MISSING_OR_INVALID", "request() params: ".concat(e)), a = _l13.message;
                throw new Error(a);

              case 3:
                s = e.topic, t = e.request, i = e.chainId, n = e.expiry;
                _context46.next = 6;
                return _this.isValidSessionTopic(s);

              case 6:
                _this$client$session$2 = _this.client.session.get(s), o = _this$client$session$2.namespaces;

                if (se(o, i)) {
                  _context46.next = 10;
                  break;
                }

                _l14 = l("MISSING_OR_INVALID", "request() chainId: ".concat(i)), _a2 = _l14.message;
                throw new Error(_a2);

              case 10:
                if (be(t)) {
                  _context46.next = 13;
                  break;
                }

                _l15 = l("MISSING_OR_INVALID", "request() ".concat(JSON.stringify(t))), _a3 = _l15.message;
                throw new Error(_a3);

              case 13:
                if (Le(o, i, t.method)) {
                  _context46.next = 16;
                  break;
                }

                _l16 = l("MISSING_OR_INVALID", "request() method: ".concat(t.method)), _a4 = _l16.message;
                throw new Error(_a4);

              case 16:
                if (!(n && !$e(n, U))) {
                  _context46.next = 19;
                  break;
                }

                _l17 = l("MISSING_OR_INVALID", "request() expiry: ".concat(n, ". Expiry must be a number (in seconds) between ").concat(U.min, " and ").concat(U.max)), _a5 = _l17.message;
                throw new Error(_a5);

              case 19:
              case "end":
                return _context46.stop();
            }
          }
        }, _callee46);
      }));

      return function (_x64) {
        return _ref51.apply(this, arguments);
      };
    }(), _this.isValidRespond = /*#__PURE__*/function () {
      var _ref52 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee47(e) {
        var _l18, i, s, t, _l19, _i2;

        return _regeneratorRuntime.wrap(function _callee47$(_context47) {
          while (1) {
            switch (_context47.prev = _context47.next) {
              case 0:
                if (E(e)) {
                  _context47.next = 3;
                  break;
                }

                _l18 = l("MISSING_OR_INVALID", "respond() params: ".concat(e)), i = _l18.message;
                throw new Error(i);

              case 3:
                s = e.topic, t = e.response;
                _context47.next = 6;
                return _this.isValidSessionTopic(s);

              case 6:
                if (Ge(t)) {
                  _context47.next = 9;
                  break;
                }

                _l19 = l("MISSING_OR_INVALID", "respond() response: ".concat(JSON.stringify(t))), _i2 = _l19.message;
                throw new Error(_i2);

              case 9:
              case "end":
                return _context47.stop();
            }
          }
        }, _callee47);
      }));

      return function (_x65) {
        return _ref52.apply(this, arguments);
      };
    }(), _this.isValidPing = /*#__PURE__*/function () {
      var _ref53 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee48(e) {
        var _l20, t, s;

        return _regeneratorRuntime.wrap(function _callee48$(_context48) {
          while (1) {
            switch (_context48.prev = _context48.next) {
              case 0:
                if (E(e)) {
                  _context48.next = 3;
                  break;
                }

                _l20 = l("MISSING_OR_INVALID", "ping() params: ".concat(e)), t = _l20.message;
                throw new Error(t);

              case 3:
                s = e.topic;
                _context48.next = 6;
                return _this.isValidSessionOrPairingTopic(s);

              case 6:
              case "end":
                return _context48.stop();
            }
          }
        }, _callee48);
      }));

      return function (_x66) {
        return _ref53.apply(this, arguments);
      };
    }(), _this.isValidEmit = /*#__PURE__*/function () {
      var _ref54 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee49(e) {
        var _l21, o, s, t, i, _this$client$session$3, n, _l22, _o, _l23, _o2, _l24, _o3;

        return _regeneratorRuntime.wrap(function _callee49$(_context49) {
          while (1) {
            switch (_context49.prev = _context49.next) {
              case 0:
                if (E(e)) {
                  _context49.next = 3;
                  break;
                }

                _l21 = l("MISSING_OR_INVALID", "emit() params: ".concat(e)), o = _l21.message;
                throw new Error(o);

              case 3:
                s = e.topic, t = e.event, i = e.chainId;
                _context49.next = 6;
                return _this.isValidSessionTopic(s);

              case 6:
                _this$client$session$3 = _this.client.session.get(s), n = _this$client$session$3.namespaces;

                if (se(n, i)) {
                  _context49.next = 10;
                  break;
                }

                _l22 = l("MISSING_OR_INVALID", "emit() chainId: ".concat(i)), _o = _l22.message;
                throw new Error(_o);

              case 10:
                if (Me(t)) {
                  _context49.next = 13;
                  break;
                }

                _l23 = l("MISSING_OR_INVALID", "emit() event: ".concat(JSON.stringify(t))), _o2 = _l23.message;
                throw new Error(_o2);

              case 13:
                if (Ue(n, i, t.name)) {
                  _context49.next = 16;
                  break;
                }

                _l24 = l("MISSING_OR_INVALID", "emit() event: ".concat(JSON.stringify(t))), _o3 = _l24.message;
                throw new Error(_o3);

              case 16:
              case "end":
                return _context49.stop();
            }
          }
        }, _callee49);
      }));

      return function (_x67) {
        return _ref54.apply(this, arguments);
      };
    }(), _this.isValidDisconnect = /*#__PURE__*/function () {
      var _ref55 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee50(e) {
        var _l25, t, s;

        return _regeneratorRuntime.wrap(function _callee50$(_context50) {
          while (1) {
            switch (_context50.prev = _context50.next) {
              case 0:
                if (E(e)) {
                  _context50.next = 3;
                  break;
                }

                _l25 = l("MISSING_OR_INVALID", "disconnect() params: ".concat(e)), t = _l25.message;
                throw new Error(t);

              case 3:
                s = e.topic;
                _context50.next = 6;
                return _this.isValidSessionOrPairingTopic(s);

              case 6:
              case "end":
                return _context50.stop();
            }
          }
        }, _callee50);
      }));

      return function (_x68) {
        return _ref55.apply(this, arguments);
      };
    }(), _this.getVerifyContext = /*#__PURE__*/function () {
      var _ref56 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee51(e, s) {
        var t, i;
        return _regeneratorRuntime.wrap(function _callee51$(_context51) {
          while (1) {
            switch (_context51.prev = _context51.next) {
              case 0:
                t = {
                  verified: {
                    verifyUrl: s.verifyUrl || me,
                    validation: "UNKNOWN",
                    origin: s.url || ""
                  }
                };
                _context51.prev = 1;
                _context51.next = 4;
                return _this.client.core.verify.resolve({
                  attestationId: e,
                  verifyUrl: s.verifyUrl
                });

              case 4:
                i = _context51.sent;
                i && (t.verified.origin = i.origin, t.verified.isScam = i.isScam, t.verified.validation = i.origin === new URL(s.url).origin ? "VALID" : "INVALID");
                _context51.next = 11;
                break;

              case 8:
                _context51.prev = 8;
                _context51.t0 = _context51["catch"](1);

                _this.client.logger.info(_context51.t0);

              case 11:
                return _context51.abrupt("return", (_this.client.logger.info("Verify context: ".concat(JSON.stringify(t))), t));

              case 12:
              case "end":
                return _context51.stop();
            }
          }
        }, _callee51, null, [[1, 8]]);
      }));

      return function (_x69, _x70) {
        return _ref56.apply(this, arguments);
      };
    }(), _this.validateSessionProps = function (e, s) {
      Object.values(e).forEach(function (t) {
        if (!C(t, !1)) {
          var _l26 = l("MISSING_OR_INVALID", "".concat(s, " must be in Record<string, string> format. Received: ").concat(JSON.stringify(t))),
              i = _l26.message;

          throw new Error(i);
        }
      });
    };
    return _this;
  }

  _createClass(ps, [{
    key: "isInitialized",
    value: function () {
      var _isInitialized = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee52() {
        var _l27, r;

        return _regeneratorRuntime.wrap(function _callee52$(_context52) {
          while (1) {
            switch (_context52.prev = _context52.next) {
              case 0:
                if (this.initialized) {
                  _context52.next = 3;
                  break;
                }

                _l27 = l("NOT_INITIALIZED", this.name), r = _l27.message;
                throw new Error(r);

              case 3:
                _context52.next = 5;
                return this.client.core.relayer.confirmOnlineStateOrThrow();

              case 5:
              case "end":
                return _context52.stop();
            }
          }
        }, _callee52, this);
      }));

      function isInitialized() {
        return _isInitialized.apply(this, arguments);
      }

      return isInitialized;
    }()
  }, {
    key: "registerRelayerEvents",
    value: function registerRelayerEvents() {
      var _this2 = this;

      this.client.core.relayer.on(Z.message, /*#__PURE__*/function () {
        var _ref57 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee53(r) {
          var e, s, t;
          return _regeneratorRuntime.wrap(function _callee53$(_context53) {
            while (1) {
              switch (_context53.prev = _context53.next) {
                case 0:
                  e = r.topic, s = r.message;

                  if (!_this2.ignoredPayloadTypes.includes(_this2.client.core.crypto.getPayloadType(s))) {
                    _context53.next = 3;
                    break;
                  }

                  return _context53.abrupt("return");

                case 3:
                  _context53.next = 5;
                  return _this2.client.core.crypto.decode(e, s);

                case 5:
                  t = _context53.sent;
                  _context53.prev = 6;

                  if (!We(t)) {
                    _context53.next = 11;
                    break;
                  }

                  _this2.client.core.history.set(e, t), _this2.onRelayEventRequest({
                    topic: e,
                    payload: t
                  });
                  _context53.next = 20;
                  break;

                case 11:
                  if (!Be(t)) {
                    _context53.next = 19;
                    break;
                  }

                  _context53.next = 14;
                  return _this2.client.core.history.resolve(t);

                case 14:
                  _context53.next = 16;
                  return _this2.onRelayEventResponse({
                    topic: e,
                    payload: t
                  });

                case 16:
                  _this2.client.core.history.delete(e, t.id);

                  _context53.next = 20;
                  break;

                case 19:
                  _this2.onRelayEventUnknownPayload({
                    topic: e,
                    payload: t
                  });

                case 20:
                  _context53.next = 25;
                  break;

                case 22:
                  _context53.prev = 22;
                  _context53.t0 = _context53["catch"](6);

                  _this2.client.logger.error(_context53.t0);

                case 25:
                case "end":
                  return _context53.stop();
              }
            }
          }, _callee53, null, [[6, 22]]);
        }));

        return function (_x71) {
          return _ref57.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "registerExpirerEvents",
    value: function registerExpirerEvents() {
      var _this3 = this;

      this.client.core.expirer.on(we.expired, /*#__PURE__*/function () {
        var _ref58 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee54(r) {
          var _Qe, e, s;

          return _regeneratorRuntime.wrap(function _callee54$(_context54) {
            while (1) {
              switch (_context54.prev = _context54.next) {
                case 0:
                  _Qe = Qe(r.target), e = _Qe.topic, s = _Qe.id;

                  if (!(s && _this3.client.pendingRequest.keys.includes(s))) {
                    _context54.next = 5;
                    break;
                  }

                  _context54.next = 4;
                  return _this3.deletePendingSessionRequest(s, l("EXPIRED"), !0);

                case 4:
                  return _context54.abrupt("return", _context54.sent);

                case 5:
                  if (!e) {
                    _context54.next = 13;
                    break;
                  }

                  _context54.t0 = _this3.client.session.keys.includes(e);

                  if (!_context54.t0) {
                    _context54.next = 11;
                    break;
                  }

                  _context54.next = 10;
                  return _this3.deleteSession(e, !0);

                case 10:
                  _this3.client.events.emit("session_expire", {
                    topic: e
                  });

                case 11:
                  _context54.next = 18;
                  break;

                case 13:
                  _context54.t1 = s;

                  if (!_context54.t1) {
                    _context54.next = 18;
                    break;
                  }

                  _context54.next = 17;
                  return _this3.deleteProposal(s, !0);

                case 17:
                  _this3.client.events.emit("proposal_expire", {
                    id: s
                  });

                case 18:
                case "end":
                  return _context54.stop();
              }
            }
          }, _callee54);
        }));

        return function (_x72) {
          return _ref58.apply(this, arguments);
        };
      }());
    }
  }, {
    key: "registerPairingEvents",
    value: function registerPairingEvents() {
      var _this4 = this;

      this.client.core.pairing.events.on(ye.create, function (r) {
        return _this4.onPairingCreated(r);
      });
    }
  }, {
    key: "isValidPairingTopic",
    value: function isValidPairingTopic(r) {
      if (!C(r, !1)) {
        var _l28 = l("MISSING_OR_INVALID", "pairing topic should be a string: ".concat(r)),
            e = _l28.message;

        throw new Error(e);
      }

      if (!this.client.core.pairing.pairings.keys.includes(r)) {
        var _l29 = l("NO_MATCHING_KEY", "pairing topic doesn't exist: ".concat(r)),
            _e2 = _l29.message;

        throw new Error(_e2);
      }

      if (P(this.client.core.pairing.pairings.get(r).expiry)) {
        var _l30 = l("EXPIRED", "pairing topic: ".concat(r)),
            _e3 = _l30.message;

        throw new Error(_e3);
      }
    }
  }, {
    key: "isValidSessionTopic",
    value: function () {
      var _isValidSessionTopic = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee55(r) {
        var _l31, e, _l32, _e4, _l33, _e5;

        return _regeneratorRuntime.wrap(function _callee55$(_context55) {
          while (1) {
            switch (_context55.prev = _context55.next) {
              case 0:
                if (C(r, !1)) {
                  _context55.next = 3;
                  break;
                }

                _l31 = l("MISSING_OR_INVALID", "session topic should be a string: ".concat(r)), e = _l31.message;
                throw new Error(e);

              case 3:
                if (this.client.session.keys.includes(r)) {
                  _context55.next = 6;
                  break;
                }

                _l32 = l("NO_MATCHING_KEY", "session topic doesn't exist: ".concat(r)), _e4 = _l32.message;
                throw new Error(_e4);

              case 6:
                if (!P(this.client.session.get(r).expiry)) {
                  _context55.next = 11;
                  break;
                }

                _context55.next = 9;
                return this.deleteSession(r);

              case 9:
                _l33 = l("EXPIRED", "session topic: ".concat(r)), _e5 = _l33.message;
                throw new Error(_e5);

              case 11:
              case "end":
                return _context55.stop();
            }
          }
        }, _callee55, this);
      }));

      function isValidSessionTopic(_x73) {
        return _isValidSessionTopic.apply(this, arguments);
      }

      return isValidSessionTopic;
    }()
  }, {
    key: "isValidSessionOrPairingTopic",
    value: function () {
      var _isValidSessionOrPairingTopic = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee56(r) {
        var _l34, e, _l35, _e6;

        return _regeneratorRuntime.wrap(function _callee56$(_context56) {
          while (1) {
            switch (_context56.prev = _context56.next) {
              case 0:
                if (!this.client.session.keys.includes(r)) {
                  _context56.next = 5;
                  break;
                }

                _context56.next = 3;
                return this.isValidSessionTopic(r);

              case 3:
                _context56.next = 16;
                break;

              case 5:
                if (!this.client.core.pairing.pairings.keys.includes(r)) {
                  _context56.next = 9;
                  break;
                }

                this.isValidPairingTopic(r);
                _context56.next = 16;
                break;

              case 9:
                if (!C(r, !1)) {
                  _context56.next = 14;
                  break;
                }

                _l34 = l("NO_MATCHING_KEY", "session or pairing topic doesn't exist: ".concat(r)), e = _l34.message;
                throw new Error(e);

              case 14:
                _l35 = l("MISSING_OR_INVALID", "session or pairing topic should be a string: ".concat(r)), _e6 = _l35.message;
                throw new Error(_e6);

              case 16:
              case "end":
                return _context56.stop();
            }
          }
        }, _callee56, this);
      }));

      function isValidSessionOrPairingTopic(_x74) {
        return _isValidSessionOrPairingTopic.apply(this, arguments);
      }

      return isValidSessionOrPairingTopic;
    }()
  }, {
    key: "isValidProposalId",
    value: function () {
      var _isValidProposalId = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee57(r) {
        var _l36, e, _l37, _e7, _l38, _e8;

        return _regeneratorRuntime.wrap(function _callee57$(_context57) {
          while (1) {
            switch (_context57.prev = _context57.next) {
              case 0:
                if (Ke(r)) {
                  _context57.next = 3;
                  break;
                }

                _l36 = l("MISSING_OR_INVALID", "proposal id should be a number: ".concat(r)), e = _l36.message;
                throw new Error(e);

              case 3:
                if (this.client.proposal.keys.includes(r)) {
                  _context57.next = 6;
                  break;
                }

                _l37 = l("NO_MATCHING_KEY", "proposal id doesn't exist: ".concat(r)), _e7 = _l37.message;
                throw new Error(_e7);

              case 6:
                if (!P(this.client.proposal.get(r).expiry)) {
                  _context57.next = 11;
                  break;
                }

                _context57.next = 9;
                return this.deleteProposal(r);

              case 9:
                _l38 = l("EXPIRED", "proposal id: ".concat(r)), _e8 = _l38.message;
                throw new Error(_e8);

              case 11:
              case "end":
                return _context57.stop();
            }
          }
        }, _callee57, this);
      }));

      function isValidProposalId(_x75) {
        return _isValidProposalId.apply(this, arguments);
      }

      return isValidProposalId;
    }()
  }]);

  return ps;
}(Ne);

var hs = /*#__PURE__*/function (_k) {
  _inherits(hs, _k);

  var _super2 = _createSuper(hs);

  function hs(r, e) {
    var _this5;

    _classCallCheck(this, hs);

    _this5 = _super2.call(this, r, e, ne, G), _this5.core = r, _this5.logger = e;
    return _this5;
  }

  return _createClass(hs);
}(k);

var ds = /*#__PURE__*/function (_k2) {
  _inherits(ds, _k2);

  var _super3 = _createSuper(ds);

  function ds(r, e) {
    var _this6;

    _classCallCheck(this, ds);

    _this6 = _super3.call(this, r, e, ae, G), _this6.core = r, _this6.logger = e;
    return _this6;
  }

  return _createClass(ds);
}(k);

var us = /*#__PURE__*/function (_k3) {
  _inherits(us, _k3);

  var _super4 = _createSuper(us);

  function us(r, e) {
    var _this7;

    _classCallCheck(this, us);

    _this7 = _super4.call(this, r, e, le, G, function (s) {
      return s.id;
    }), _this7.core = r, _this7.logger = e;
    return _this7;
  }

  return _createClass(us);
}(k);

var Q = /*#__PURE__*/function (_qe) {
  _inherits(Q, _qe);

  var _super5 = _createSuper(Q);

  function Q(r) {
    var _this8;

    _classCallCheck(this, Q);

    _this8 = _super5.call(this, r), _this8.protocol = X, _this8.version = F, _this8.name = M.name, _this8.events = new Ye(), _this8.on = function (s, t) {
      return _this8.events.on(s, t);
    }, _this8.once = function (s, t) {
      return _this8.events.once(s, t);
    }, _this8.off = function (s, t) {
      return _this8.events.off(s, t);
    }, _this8.removeListener = function (s, t) {
      return _this8.events.removeListener(s, t);
    }, _this8.removeAllListeners = function (s) {
      return _this8.events.removeAllListeners(s);
    }, _this8.connect = /*#__PURE__*/function () {
      var _ref59 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee58(s) {
        return _regeneratorRuntime.wrap(function _callee58$(_context58) {
          while (1) {
            switch (_context58.prev = _context58.next) {
              case 0:
                _context58.prev = 0;
                _context58.next = 3;
                return _this8.engine.connect(s);

              case 3:
                return _context58.abrupt("return", _context58.sent);

              case 6:
                _context58.prev = 6;
                _context58.t0 = _context58["catch"](0);
                throw _this8.logger.error(_context58.t0.message), _context58.t0;

              case 9:
              case "end":
                return _context58.stop();
            }
          }
        }, _callee58, null, [[0, 6]]);
      }));

      return function (_x76) {
        return _ref59.apply(this, arguments);
      };
    }(), _this8.pair = /*#__PURE__*/function () {
      var _ref60 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee59(s) {
        return _regeneratorRuntime.wrap(function _callee59$(_context59) {
          while (1) {
            switch (_context59.prev = _context59.next) {
              case 0:
                _context59.prev = 0;
                _context59.next = 3;
                return _this8.engine.pair(s);

              case 3:
                return _context59.abrupt("return", _context59.sent);

              case 6:
                _context59.prev = 6;
                _context59.t0 = _context59["catch"](0);
                throw _this8.logger.error(_context59.t0.message), _context59.t0;

              case 9:
              case "end":
                return _context59.stop();
            }
          }
        }, _callee59, null, [[0, 6]]);
      }));

      return function (_x77) {
        return _ref60.apply(this, arguments);
      };
    }(), _this8.approve = /*#__PURE__*/function () {
      var _ref61 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee60(s) {
        return _regeneratorRuntime.wrap(function _callee60$(_context60) {
          while (1) {
            switch (_context60.prev = _context60.next) {
              case 0:
                _context60.prev = 0;
                _context60.next = 3;
                return _this8.engine.approve(s);

              case 3:
                return _context60.abrupt("return", _context60.sent);

              case 6:
                _context60.prev = 6;
                _context60.t0 = _context60["catch"](0);
                throw _this8.logger.error(_context60.t0.message), _context60.t0;

              case 9:
              case "end":
                return _context60.stop();
            }
          }
        }, _callee60, null, [[0, 6]]);
      }));

      return function (_x78) {
        return _ref61.apply(this, arguments);
      };
    }(), _this8.reject = /*#__PURE__*/function () {
      var _ref62 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee61(s) {
        return _regeneratorRuntime.wrap(function _callee61$(_context61) {
          while (1) {
            switch (_context61.prev = _context61.next) {
              case 0:
                _context61.prev = 0;
                _context61.next = 3;
                return _this8.engine.reject(s);

              case 3:
                return _context61.abrupt("return", _context61.sent);

              case 6:
                _context61.prev = 6;
                _context61.t0 = _context61["catch"](0);
                throw _this8.logger.error(_context61.t0.message), _context61.t0;

              case 9:
              case "end":
                return _context61.stop();
            }
          }
        }, _callee61, null, [[0, 6]]);
      }));

      return function (_x79) {
        return _ref62.apply(this, arguments);
      };
    }(), _this8.update = /*#__PURE__*/function () {
      var _ref63 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee62(s) {
        return _regeneratorRuntime.wrap(function _callee62$(_context62) {
          while (1) {
            switch (_context62.prev = _context62.next) {
              case 0:
                _context62.prev = 0;
                _context62.next = 3;
                return _this8.engine.update(s);

              case 3:
                return _context62.abrupt("return", _context62.sent);

              case 6:
                _context62.prev = 6;
                _context62.t0 = _context62["catch"](0);
                throw _this8.logger.error(_context62.t0.message), _context62.t0;

              case 9:
              case "end":
                return _context62.stop();
            }
          }
        }, _callee62, null, [[0, 6]]);
      }));

      return function (_x80) {
        return _ref63.apply(this, arguments);
      };
    }(), _this8.extend = /*#__PURE__*/function () {
      var _ref64 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee63(s) {
        return _regeneratorRuntime.wrap(function _callee63$(_context63) {
          while (1) {
            switch (_context63.prev = _context63.next) {
              case 0:
                _context63.prev = 0;
                _context63.next = 3;
                return _this8.engine.extend(s);

              case 3:
                return _context63.abrupt("return", _context63.sent);

              case 6:
                _context63.prev = 6;
                _context63.t0 = _context63["catch"](0);
                throw _this8.logger.error(_context63.t0.message), _context63.t0;

              case 9:
              case "end":
                return _context63.stop();
            }
          }
        }, _callee63, null, [[0, 6]]);
      }));

      return function (_x81) {
        return _ref64.apply(this, arguments);
      };
    }(), _this8.request = /*#__PURE__*/function () {
      var _ref65 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee64(s) {
        return _regeneratorRuntime.wrap(function _callee64$(_context64) {
          while (1) {
            switch (_context64.prev = _context64.next) {
              case 0:
                _context64.prev = 0;
                _context64.next = 3;
                return _this8.engine.request(s);

              case 3:
                return _context64.abrupt("return", _context64.sent);

              case 6:
                _context64.prev = 6;
                _context64.t0 = _context64["catch"](0);
                throw _this8.logger.error(_context64.t0.message), _context64.t0;

              case 9:
              case "end":
                return _context64.stop();
            }
          }
        }, _callee64, null, [[0, 6]]);
      }));

      return function (_x82) {
        return _ref65.apply(this, arguments);
      };
    }(), _this8.respond = /*#__PURE__*/function () {
      var _ref66 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee65(s) {
        return _regeneratorRuntime.wrap(function _callee65$(_context65) {
          while (1) {
            switch (_context65.prev = _context65.next) {
              case 0:
                _context65.prev = 0;
                _context65.next = 3;
                return _this8.engine.respond(s);

              case 3:
                return _context65.abrupt("return", _context65.sent);

              case 6:
                _context65.prev = 6;
                _context65.t0 = _context65["catch"](0);
                throw _this8.logger.error(_context65.t0.message), _context65.t0;

              case 9:
              case "end":
                return _context65.stop();
            }
          }
        }, _callee65, null, [[0, 6]]);
      }));

      return function (_x83) {
        return _ref66.apply(this, arguments);
      };
    }(), _this8.ping = /*#__PURE__*/function () {
      var _ref67 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee66(s) {
        return _regeneratorRuntime.wrap(function _callee66$(_context66) {
          while (1) {
            switch (_context66.prev = _context66.next) {
              case 0:
                _context66.prev = 0;
                _context66.next = 3;
                return _this8.engine.ping(s);

              case 3:
                return _context66.abrupt("return", _context66.sent);

              case 6:
                _context66.prev = 6;
                _context66.t0 = _context66["catch"](0);
                throw _this8.logger.error(_context66.t0.message), _context66.t0;

              case 9:
              case "end":
                return _context66.stop();
            }
          }
        }, _callee66, null, [[0, 6]]);
      }));

      return function (_x84) {
        return _ref67.apply(this, arguments);
      };
    }(), _this8.emit = /*#__PURE__*/function () {
      var _ref68 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee67(s) {
        return _regeneratorRuntime.wrap(function _callee67$(_context67) {
          while (1) {
            switch (_context67.prev = _context67.next) {
              case 0:
                _context67.prev = 0;
                _context67.next = 3;
                return _this8.engine.emit(s);

              case 3:
                return _context67.abrupt("return", _context67.sent);

              case 6:
                _context67.prev = 6;
                _context67.t0 = _context67["catch"](0);
                throw _this8.logger.error(_context67.t0.message), _context67.t0;

              case 9:
              case "end":
                return _context67.stop();
            }
          }
        }, _callee67, null, [[0, 6]]);
      }));

      return function (_x85) {
        return _ref68.apply(this, arguments);
      };
    }(), _this8.disconnect = /*#__PURE__*/function () {
      var _ref69 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee68(s) {
        return _regeneratorRuntime.wrap(function _callee68$(_context68) {
          while (1) {
            switch (_context68.prev = _context68.next) {
              case 0:
                _context68.prev = 0;
                _context68.next = 3;
                return _this8.engine.disconnect(s);

              case 3:
                return _context68.abrupt("return", _context68.sent);

              case 6:
                _context68.prev = 6;
                _context68.t0 = _context68["catch"](0);
                throw _this8.logger.error(_context68.t0.message), _context68.t0;

              case 9:
              case "end":
                return _context68.stop();
            }
          }
        }, _callee68, null, [[0, 6]]);
      }));

      return function (_x86) {
        return _ref69.apply(this, arguments);
      };
    }(), _this8.find = function (s) {
      try {
        return _this8.engine.find(s);
      } catch (t) {
        throw _this8.logger.error(t.message), t;
      }
    }, _this8.getPendingSessionRequests = function () {
      try {
        return _this8.engine.getPendingSessionRequests();
      } catch (s) {
        throw _this8.logger.error(s.message), s;
      }
    }, _this8.name = (r === null || r === void 0 ? void 0 : r.name) || M.name, _this8.metadata = (r === null || r === void 0 ? void 0 : r.metadata) || ke();
    var e = typeof (r === null || r === void 0 ? void 0 : r.logger) < "u" && typeof (r === null || r === void 0 ? void 0 : r.logger) != "string" ? r.logger : Ee(Re({
      level: (r === null || r === void 0 ? void 0 : r.logger) || M.logger
    }));
    _this8.core = (r === null || r === void 0 ? void 0 : r.core) || new Se(r), _this8.logger = Ie(e, _this8.name), _this8.session = new ds(_this8.core, _this8.logger), _this8.proposal = new hs(_this8.core, _this8.logger), _this8.pendingRequest = new us(_this8.core, _this8.logger), _this8.engine = new ps(_assertThisInitialized(_this8));
    return _this8;
  }

  _createClass(Q, [{
    key: "context",
    get: function get() {
      return _e(this.logger);
    }
  }, {
    key: "pairing",
    get: function get() {
      return this.core.pairing.pairings;
    }
  }, {
    key: "initialize",
    value: function () {
      var _initialize = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee69() {
        return _regeneratorRuntime.wrap(function _callee69$(_context69) {
          while (1) {
            switch (_context69.prev = _context69.next) {
              case 0:
                this.logger.trace("Initialized");
                _context69.prev = 1;
                _context69.next = 4;
                return this.core.start();

              case 4:
                _context69.next = 6;
                return this.session.init();

              case 6:
                _context69.next = 8;
                return this.proposal.init();

              case 8:
                _context69.next = 10;
                return this.pendingRequest.init();

              case 10:
                _context69.next = 12;
                return this.engine.init();

              case 12:
                this.core.verify.init({
                  verifyUrl: this.metadata.verifyUrl
                });
                this.logger.info("SignClient Initialization Success");
                _context69.next = 19;
                break;

              case 16:
                _context69.prev = 16;
                _context69.t0 = _context69["catch"](1);
                throw this.logger.info("SignClient Initialization Failure"), this.logger.error(_context69.t0.message), _context69.t0;

              case 19:
              case "end":
                return _context69.stop();
            }
          }
        }, _callee69, this, [[1, 16]]);
      }));

      function initialize() {
        return _initialize.apply(this, arguments);
      }

      return initialize;
    }()
  }], [{
    key: "init",
    value: function () {
      var _init = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee70(r) {
        var e;
        return _regeneratorRuntime.wrap(function _callee70$(_context70) {
          while (1) {
            switch (_context70.prev = _context70.next) {
              case 0:
                e = new Q(r);
                _context70.next = 3;
                return e.initialize();

              case 3:
                return _context70.abrupt("return", e);

              case 4:
              case "end":
                return _context70.stop();
            }
          }
        }, _callee70);
      }));

      function init(_x87) {
        return _init.apply(this, arguments);
      }

      return init;
    }()
  }]);

  return Q;
}(qe);

var gs = Q;
export { ce as ENGINE_CONTEXT, I as ENGINE_QUEUE_STATES, V as ENGINE_RPC_OPTS, ts as HISTORY_CONTEXT, ss as HISTORY_EVENTS, is as HISTORY_STORAGE_VERSION, pe as METHODS_TO_VERIFY, ne as PROPOSAL_CONTEXT, rs as PROPOSAL_EXPIRY, oe as PROPOSAL_EXPIRY_MESSAGE, le as REQUEST_CONTEXT, ae as SESSION_CONTEXT, A as SESSION_EXPIRY, U as SESSION_REQUEST_EXPIRY_BOUNDARIES, H as SIGN_CLIENT_CONTEXT, M as SIGN_CLIENT_DEFAULT, Ze as SIGN_CLIENT_EVENTS, X as SIGN_CLIENT_PROTOCOL, es as SIGN_CLIENT_STORAGE_OPTIONS, G as SIGN_CLIENT_STORAGE_PREFIX, F as SIGN_CLIENT_VERSION, gs as SignClient, W as WALLETCONNECT_DEEPLINK_CHOICE, Q as default };